<script lang="ts">
  import { Info } from "svelte-feathers"
  import AddMilestoneButton from "./MilestoneEditor/AddMilestoneButton.svelte"
  import { Milestone } from "@models/milestones/Milestone"
  import { Package } from "@models/trips/Package"
  import MilestoneForm from "./MilestoneEditor/MilestoneForm.svelte"
  import MilestonePreview from "./MilestoneEditor/MilestonePreview.svelte"
  export let milestones: Milestone[]
  export let packages: Package[]
  export let tripId: number
  export let registrationClosesOn: string
  export let readOnly: false
  export let lateRegistrantPaymentStrategy: "catch_up" | "distribute" = "catch_up"

  $: showDistributeStrategyInfo = lateRegistrantPaymentStrategy === "distribute" && !readOnly

  function milestonePath(milestone) {
    if (milestone.id) {
      return `/api/v1/trips/${milestone.tripId}/milestone_dates/${milestone.id}`
    } else {
      return `/api/v1/trips/${milestone.tripId}/milestone_dates/`
    }
  }
</script>

{#if showDistributeStrategyInfo}
  <div class="callout-box border-gray-200 mb-4">
    <div class="icon-col svg-icon-lg text-gray-700">
      <Info size="20" />
    </div>
    <div class="content-col">
      <strong>Distribute Strategy Active</strong>
      <p class="mt-1 text-sm text-gray-600">
        When using the "distribute" late registrant payment strategy, only the first payment (deposit) can be a fixed dollar amount. All subsequent payments must be percentage-based to allow proper distribution of remaining balances.
      </p>
    </div>
  </div>
{/if}

<div class="fake-table-component border-gray-200">
  {#if milestones.length <= 1 && !readOnly}
    <AddMilestoneButton bind:milestones {tripId} {lateRegistrantPaymentStrategy} />
  {/if}
  {#each milestones as milestone, index}
    <div>
      {#if milestone.isEditing}
        <MilestoneForm bind:milestones bind:milestone {registrationClosesOn} path={milestonePath(milestone)} {lateRegistrantPaymentStrategy} {index} />
      {:else}
        <MilestonePreview bind:milestones bind:milestone {packages} path={milestonePath(milestone)} {readOnly} {lateRegistrantPaymentStrategy} {index} />
      {/if}
    </div>

    {#if milestones.length === index + 2 && !readOnly}
      <AddMilestoneButton bind:milestones {tripId} {lateRegistrantPaymentStrategy} />
    {/if}
  {/each}
</div>
